var path = '/static/assets/khapps/dss/dss_irrigation/partials/includes/chart_configuration.html';
var html = "<highchart id=\"{{ chartId }}\" config=\"{{ chartConfiguration }}\"></highchart>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;